import styles from '../AttachmentImageGallery.module.scss'

export const attachmentGalleryDialogSlotProps = {
  backdrop: { className: styles.backdrop, sx: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } },
  paper: {
    elevation: 0,
    className: styles.paper,
    sx: { backgroundColor: 'transparent', backgroundImage: 'none', boxShadow: 'none' },
  },
}
